var $f8f743cd82682895$var$i = Symbol.for("preact-signals");
function $f8f743cd82682895$var$t() {
    if (!($f8f743cd82682895$var$s > 1)) {
        var i, t = !1;
        while(void 0 !== $f8f743cd82682895$var$h){
            var r = $f8f743cd82682895$var$h;
            $f8f743cd82682895$var$h = void 0;
            $f8f743cd82682895$var$f++;
            while(void 0 !== r){
                var o = r.o;
                r.o = void 0;
                r.f &= -3;
                if (!(8 & r.f) && $f8f743cd82682895$var$c(r)) try {
                    r.c();
                } catch (r) {
                    if (!t) {
                        i = r;
                        t = !0;
                    }
                }
                r = o;
            }
        }
        $f8f743cd82682895$var$f = 0;
        $f8f743cd82682895$var$s--;
        if (t) throw i;
    } else $f8f743cd82682895$var$s--;
}
function $f8f743cd82682895$export$712ea50be43a7858(i) {
    if ($f8f743cd82682895$var$s > 0) return i();
    $f8f743cd82682895$var$s++;
    try {
        return i();
    } finally{
        $f8f743cd82682895$var$t();
    }
}
var $f8f743cd82682895$var$o = void 0;
function $f8f743cd82682895$export$8c437e4d572e2f99(i) {
    var t = $f8f743cd82682895$var$o;
    $f8f743cd82682895$var$o = void 0;
    try {
        return i();
    } finally{
        $f8f743cd82682895$var$o = t;
    }
}
var $f8f743cd82682895$var$h = void 0, $f8f743cd82682895$var$s = 0, $f8f743cd82682895$var$f = 0, $f8f743cd82682895$var$v = 0;
function $f8f743cd82682895$var$e(i) {
    if (void 0 !== $f8f743cd82682895$var$o) {
        var t = i.n;
        if (void 0 === t || t.t !== $f8f743cd82682895$var$o) {
            t = {
                i: 0,
                S: i,
                p: $f8f743cd82682895$var$o.s,
                n: void 0,
                t: $f8f743cd82682895$var$o,
                e: void 0,
                x: void 0,
                r: t
            };
            if (void 0 !== $f8f743cd82682895$var$o.s) $f8f743cd82682895$var$o.s.n = t;
            $f8f743cd82682895$var$o.s = t;
            i.n = t;
            if (32 & $f8f743cd82682895$var$o.f) i.S(t);
            return t;
        } else if (-1 === t.i) {
            t.i = 0;
            if (void 0 !== t.n) {
                t.n.p = t.p;
                if (void 0 !== t.p) t.p.n = t.n;
                t.p = $f8f743cd82682895$var$o.s;
                t.n = void 0;
                $f8f743cd82682895$var$o.s.n = t;
                $f8f743cd82682895$var$o.s = t;
            }
            return t;
        }
    }
}
function $f8f743cd82682895$export$8210dfe1863c478(i) {
    this.v = i;
    this.i = 0;
    this.n = void 0;
    this.t = void 0;
}
$f8f743cd82682895$export$8210dfe1863c478.prototype.brand = $f8f743cd82682895$var$i;
$f8f743cd82682895$export$8210dfe1863c478.prototype.h = function() {
    return !0;
};
$f8f743cd82682895$export$8210dfe1863c478.prototype.S = function(i) {
    if (this.t !== i && void 0 === i.e) {
        i.x = this.t;
        if (void 0 !== this.t) this.t.e = i;
        this.t = i;
    }
};
$f8f743cd82682895$export$8210dfe1863c478.prototype.U = function(i) {
    if (void 0 !== this.t) {
        var t = i.e, r = i.x;
        if (void 0 !== t) {
            t.x = r;
            i.e = void 0;
        }
        if (void 0 !== r) {
            r.e = t;
            i.x = void 0;
        }
        if (i === this.t) this.t = r;
    }
};
$f8f743cd82682895$export$8210dfe1863c478.prototype.subscribe = function(i) {
    var t = this;
    return $f8f743cd82682895$export$dc573d8a6576cdb3(function() {
        var r = t.value, n = $f8f743cd82682895$var$o;
        $f8f743cd82682895$var$o = void 0;
        try {
            i(r);
        } finally{
            $f8f743cd82682895$var$o = n;
        }
    });
};
$f8f743cd82682895$export$8210dfe1863c478.prototype.valueOf = function() {
    return this.value;
};
$f8f743cd82682895$export$8210dfe1863c478.prototype.toString = function() {
    return this.value + "";
};
$f8f743cd82682895$export$8210dfe1863c478.prototype.toJSON = function() {
    return this.value;
};
$f8f743cd82682895$export$8210dfe1863c478.prototype.peek = function() {
    var i = $f8f743cd82682895$var$o;
    $f8f743cd82682895$var$o = void 0;
    try {
        return this.value;
    } finally{
        $f8f743cd82682895$var$o = i;
    }
};
Object.defineProperty($f8f743cd82682895$export$8210dfe1863c478.prototype, "value", {
    get: function() {
        var i = $f8f743cd82682895$var$e(this);
        if (void 0 !== i) i.i = this.i;
        return this.v;
    },
    set: function(i) {
        if (i !== this.v) {
            if ($f8f743cd82682895$var$f > 100) throw new Error("Cycle detected");
            this.v = i;
            this.i++;
            $f8f743cd82682895$var$v++;
            $f8f743cd82682895$var$s++;
            try {
                for(var r = this.t; void 0 !== r; r = r.x)r.t.N();
            } finally{
                $f8f743cd82682895$var$t();
            }
        }
    }
});
function $f8f743cd82682895$export$e2ef10f86a8d60e8(i) {
    return new $f8f743cd82682895$export$8210dfe1863c478(i);
}
function $f8f743cd82682895$var$c(i) {
    for(var t = i.s; void 0 !== t; t = t.n)if (t.S.i !== t.i || !t.S.h() || t.S.i !== t.i) return !0;
    return !1;
}
function $f8f743cd82682895$var$a(i) {
    for(var t = i.s; void 0 !== t; t = t.n){
        var r = t.S.n;
        if (void 0 !== r) t.r = r;
        t.S.n = t;
        t.i = -1;
        if (void 0 === t.n) {
            i.s = t;
            break;
        }
    }
}
function $f8f743cd82682895$var$l(i) {
    var t = i.s, r = void 0;
    while(void 0 !== t){
        var o = t.p;
        if (-1 === t.i) {
            t.S.U(t);
            if (void 0 !== o) o.n = t.n;
            if (void 0 !== t.n) t.n.p = o;
        } else r = t;
        t.S.n = t.r;
        if (void 0 !== t.r) t.r = void 0;
        t = o;
    }
    i.s = r;
}
function $f8f743cd82682895$var$y(i) {
    $f8f743cd82682895$export$8210dfe1863c478.call(this, void 0);
    this.x = i;
    this.s = void 0;
    this.g = $f8f743cd82682895$var$v - 1;
    this.f = 4;
}
($f8f743cd82682895$var$y.prototype = new $f8f743cd82682895$export$8210dfe1863c478).h = function() {
    this.f &= -3;
    if (1 & this.f) return !1;
    if (32 == (36 & this.f)) return !0;
    this.f &= -5;
    if (this.g === $f8f743cd82682895$var$v) return !0;
    this.g = $f8f743cd82682895$var$v;
    this.f |= 1;
    if (this.i > 0 && !$f8f743cd82682895$var$c(this)) {
        this.f &= -2;
        return !0;
    }
    var i = $f8f743cd82682895$var$o;
    try {
        $f8f743cd82682895$var$a(this);
        $f8f743cd82682895$var$o = this;
        var t = this.x();
        if (16 & this.f || this.v !== t || 0 === this.i) {
            this.v = t;
            this.f &= -17;
            this.i++;
        }
    } catch (i) {
        this.v = i;
        this.f |= 16;
        this.i++;
    }
    $f8f743cd82682895$var$o = i;
    $f8f743cd82682895$var$l(this);
    this.f &= -2;
    return !0;
};
$f8f743cd82682895$var$y.prototype.S = function(i) {
    if (void 0 === this.t) {
        this.f |= 36;
        for(var t = this.s; void 0 !== t; t = t.n)t.S.S(t);
    }
    $f8f743cd82682895$export$8210dfe1863c478.prototype.S.call(this, i);
};
$f8f743cd82682895$var$y.prototype.U = function(i) {
    if (void 0 !== this.t) {
        $f8f743cd82682895$export$8210dfe1863c478.prototype.U.call(this, i);
        if (void 0 === this.t) {
            this.f &= -33;
            for(var t = this.s; void 0 !== t; t = t.n)t.S.U(t);
        }
    }
};
$f8f743cd82682895$var$y.prototype.N = function() {
    if (!(2 & this.f)) {
        this.f |= 6;
        for(var i = this.t; void 0 !== i; i = i.x)i.t.N();
    }
};
Object.defineProperty($f8f743cd82682895$var$y.prototype, "value", {
    get: function() {
        if (1 & this.f) throw new Error("Cycle detected");
        var i = $f8f743cd82682895$var$e(this);
        this.h();
        if (void 0 !== i) i.i = this.i;
        if (16 & this.f) throw this.v;
        return this.v;
    }
});
function $f8f743cd82682895$export$2983e091f1a1e8e2(i) {
    return new $f8f743cd82682895$var$y(i);
}
function $f8f743cd82682895$var$_(i) {
    var r = i.u;
    i.u = void 0;
    if ("function" == typeof r) {
        $f8f743cd82682895$var$s++;
        var n = $f8f743cd82682895$var$o;
        $f8f743cd82682895$var$o = void 0;
        try {
            r();
        } catch (t) {
            i.f &= -2;
            i.f |= 8;
            $f8f743cd82682895$var$g(i);
            throw t;
        } finally{
            $f8f743cd82682895$var$o = n;
            $f8f743cd82682895$var$t();
        }
    }
}
function $f8f743cd82682895$var$g(i) {
    for(var t = i.s; void 0 !== t; t = t.n)t.S.U(t);
    i.x = void 0;
    i.s = void 0;
    $f8f743cd82682895$var$_(i);
}
function $f8f743cd82682895$var$p(i) {
    if ($f8f743cd82682895$var$o !== this) throw new Error("Out-of-order effect");
    $f8f743cd82682895$var$l(this);
    $f8f743cd82682895$var$o = i;
    this.f &= -2;
    if (8 & this.f) $f8f743cd82682895$var$g(this);
    $f8f743cd82682895$var$t();
}
function $f8f743cd82682895$var$b(i) {
    this.x = i;
    this.u = void 0;
    this.s = void 0;
    this.o = void 0;
    this.f = 32;
}
$f8f743cd82682895$var$b.prototype.c = function() {
    var i = this.S();
    try {
        if (8 & this.f) return;
        if (void 0 === this.x) return;
        var t = this.x();
        if ("function" == typeof t) this.u = t;
    } finally{
        i();
    }
};
$f8f743cd82682895$var$b.prototype.S = function() {
    if (1 & this.f) throw new Error("Cycle detected");
    this.f |= 1;
    this.f &= -9;
    $f8f743cd82682895$var$_(this);
    $f8f743cd82682895$var$a(this);
    $f8f743cd82682895$var$s++;
    var i = $f8f743cd82682895$var$o;
    $f8f743cd82682895$var$o = this;
    return $f8f743cd82682895$var$p.bind(this, i);
};
$f8f743cd82682895$var$b.prototype.N = function() {
    if (!(2 & this.f)) {
        this.f |= 2;
        this.o = $f8f743cd82682895$var$h;
        $f8f743cd82682895$var$h = this;
    }
};
$f8f743cd82682895$var$b.prototype.d = function() {
    this.f |= 8;
    if (!(1 & this.f)) $f8f743cd82682895$var$g(this);
};
function $f8f743cd82682895$export$dc573d8a6576cdb3(i) {
    var t = new $f8f743cd82682895$var$b(i);
    try {
        t.c();
    } catch (i) {
        t.d();
        throw i;
    }
    return t.d.bind(t);
}


const $1e6a16da88d577c6$var$tests = document.getElementById("tests").children; // 测试题目列表
const $1e6a16da88d577c6$var$alignments = document.getElementById("alignments").children; // 结果列表
const $1e6a16da88d577c6$var$progress = document.getElementById("progress"); // 进度条
const $1e6a16da88d577c6$var$prev = document.getElementById("prev"); // 上一题按钮
// 测试题目总数
const $1e6a16da88d577c6$var$total = $1e6a16da88d577c6$var$tests.length;
$1e6a16da88d577c6$var$progress.setAttribute("max", ($1e6a16da88d577c6$var$total - 1).toString());
// 选项随机排列
for (const test of $1e6a16da88d577c6$var$tests){
    const options = Array.from(test.children).slice(1);
    const shuffled = Array.from(options).sort(()=>Math.random() - 0.5);
    for (const option of shuffled)test.appendChild(option);
}
// 当前测试题目索引
const $1e6a16da88d577c6$var$current = (0, $f8f743cd82682895$export$e2ef10f86a8d60e8)(0);
// 当前完成的测试数量
const $1e6a16da88d577c6$var$completed = (0, $f8f743cd82682895$export$e2ef10f86a8d60e8)(0);
// 当前显示的测试题目索引
let $1e6a16da88d577c6$var$active = null;
// 当前测试题目索引变化时，更新显示的测试题目
(0, $f8f743cd82682895$export$dc573d8a6576cdb3)(()=>{
    if ($1e6a16da88d577c6$var$active !== null) $1e6a16da88d577c6$var$tests[$1e6a16da88d577c6$var$active].classList.remove("active");
    $1e6a16da88d577c6$var$active = $1e6a16da88d577c6$var$current.value;
    $1e6a16da88d577c6$var$tests[$1e6a16da88d577c6$var$active].classList.add("active");
    $1e6a16da88d577c6$var$progress.setAttribute("value", $1e6a16da88d577c6$var$active.toString());
});
// 作答后
document.querySelectorAll('input[type="radio"]').forEach((radio)=>{
    radio.addEventListener("change", ()=>{
        // 自动跳转到下一题
        if ($1e6a16da88d577c6$var$current.value < $1e6a16da88d577c6$var$total - 1) setTimeout(()=>$1e6a16da88d577c6$var$current.value++, 350);
        // 更新已完成的测试数量
        $1e6a16da88d577c6$var$completed.value = document.querySelectorAll('input[type="radio"]:checked').length;
        // 显示测试结果(如果所有测试都已完成)
        $1e6a16da88d577c6$var$showResult();
    });
});
// 点击上一题
$1e6a16da88d577c6$var$prev.addEventListener("click", ()=>{
    if ($1e6a16da88d577c6$var$current.value > 0) $1e6a16da88d577c6$var$current.value--;
});
// 如果当前是第一题，则隐藏上一题按钮
(0, $f8f743cd82682895$export$dc573d8a6576cdb3)(()=>{
    $1e6a16da88d577c6$var$prev.style.display = $1e6a16da88d577c6$var$current.value > 0 ? "block" : "none";
});
// 显示测试结果
function $1e6a16da88d577c6$var$showResult() {
    if ($1e6a16da88d577c6$var$completed.value < $1e6a16da88d577c6$var$total) return;
    const affects = {
        "cx": 0,
        "lx": 0,
        "nx": 0,
        "xe": 0,
        "xg": 0,
        "xn": 0 // neutral (e vs g)
    };
    document.querySelectorAll('input[type="radio"]:checked').forEach((radio)=>{
        const infl = radio.getAttribute("data-infl");
        const value = parseInt(radio.getAttribute("data-value"));
        affects[infl] += value;
    });
    let maxScore = 0;
    let maxAlignment = "";
    for (const alignment of $1e6a16da88d577c6$var$alignments){
        const tag = alignment.getAttribute("data-alignment");
        const lawful = affects[tag[0] + "x"];
        const good = affects["x" + tag[1]];
        const score = lawful + good;
        if (score > maxScore) {
            maxScore = score;
            maxAlignment = tag;
        }
    }
    for (const alignment of $1e6a16da88d577c6$var$alignments)if (alignment.getAttribute("data-alignment") === maxAlignment) alignment.classList.add("active");
    else alignment.classList.remove("active");
}
(0, $f8f743cd82682895$export$dc573d8a6576cdb3)($1e6a16da88d577c6$var$showResult);


//# sourceMappingURL=index.a8316ed7.js.map
